/**
 * Tiny client-error reporter.
 * Sends runtime/render errors to /api/dev/client-error so we can debug
 * crashes that only repro on real devices (e.g. iPhone Safari).
 *
 * Uses sendBeacon when possible (works during page unload) and falls back
 * to fetch with keepalive. Never throws — failures are silent.
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const ENDPOINT = BACKEND_URL ? `${BACKEND_URL}/api/dev/client-error` : "/api/dev/client-error";

let recentSignatures = new Set();
function isDuplicate(sig) {
  if (recentSignatures.has(sig)) return true;
  recentSignatures.add(sig);
  if (recentSignatures.size > 50) {
    recentSignatures = new Set(Array.from(recentSignatures).slice(-25));
  }
  return false;
}

export function reportClientError(payload = {}) {
  try {
    if (typeof window === "undefined") return;
    const body = JSON.stringify({
      type: payload.type || "unknown",
      message: payload.message || "",
      stack: payload.stack || "",
      component_stack: payload.component_stack || "",
      url: payload.url || window.location.href,
      extra: payload.extra || {},
    });
    const sig = (payload.type || "") + "|" + (payload.message || "").slice(0, 200);
    if (isDuplicate(sig)) return;
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: "application/json" });
      navigator.sendBeacon(ENDPOINT, blob);
      return;
    }
    fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch (_) {
    /* never throw */
  }
}
